'use client';

import { prefetchDNS } from 'react-dom';

export const Prefetch = (): null => {
  prefetchDNS('https://cdn.segment.com');
  return null;
};
